// extracted by mini-css-extract-plugin
export default {"info":"Info_info__rC8LK","textCenter":"Info_textCenter__mxhC5","smallInfo":"Info_smallInfo__tntFH","warning":"Info_warning__mXwzW"};